import { Alert, Button, Dialog } from "@platform/ui";
import { useT } from "../../i18n";
import { CopyButton } from "../../lib/copy";

/** Shows a client secret exactly once. */
export function SecretDialog({
  clientId,
  secret,
  onClose,
}: {
  clientId: string;
  secret: string | null;
  onClose: () => void;
}) {
  const { t } = useT();
  return (
    <Dialog
      open={secret !== null}
      onOpenChange={(o) => !o && onClose()}
      title={t("clients.secretTitle")}
      closeLabel={t("common.close")}
      footer={<Button onClick={onClose}>{t("clients.secretDone")}</Button>}
    >
      <Alert tone="warning" className="mb-4">
        {t("clients.secretWarning")}
      </Alert>
      <p className="mb-1 text-xs text-ink-2">client_id</p>
      <div className="mb-3 flex items-center gap-2 rounded bg-hover px-3 py-2">
        <code className="flex-1 font-mono text-sm break-all">{clientId}</code>
        <CopyButton value={clientId} />
      </div>
      <p className="mb-1 text-xs text-ink-2">client_secret</p>
      <div className="flex items-center gap-2 rounded bg-hover px-3 py-2">
        <code data-testid="client-secret-value" className="flex-1 font-mono text-sm break-all">
          {secret}
        </code>
        {secret && <CopyButton value={secret} />}
      </div>
    </Dialog>
  );
}
